import { AttachedActionContext } from '../../context/AttachedActionContext';
export class EventAttachedAction {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    currentActionAt;
    memoized_context;
    context_for_at;
    get context() {
        if (this.context_for_at === this.currentActionAt) {
            return this.memoized_context;
        }
        const context = new AttachedActionContext({ event: this.parent, at: this.currentActionAt });
        this.memoized_context = context;
        this.context_for_at = this.currentActionAt;
        return context;
    }
}
